<template>
  <div id="app">
    <transition :name="states">
        <router-view class="router" v-wechat-title="$route.meta.title"/>
    </transition>
  </div>  
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: 'app',
    computed: {
      ...mapGetters([
        'states'
      ])
    }
  };
</script>

<style>
  #app{
    -webkit-overflow-scrolling: touch;
  }
  html,body,#app{
    height: 100%;
  }
  body{
    margin:0
  }

  *{
    -webkit-touch-callout:none;  /*系统默认菜单被禁用*/
    -webkit-user-select:none; /*webkit浏览器*/
    -moz-user-select:none;/*火狐*/
    -ms-user-select:none; /*IE10*/
    user-select:none;
  }

  input,textarea {
    -webkit-user-select:auto; /*webkit浏览器*/
  }
  .van-dialog__message{
    text-align:center;
  }
</style>

<style lang="less" scoped>
  #app{
    .router{
      position: absolute;
      width:100%;
    }

    .move-left-enter {
      transform: translate(100%);
    }
    .move-left-enter-active {
      transition: all 0.2s ease;
    }
    .move-left-leave-active {
      transform: translate(-100%);
      transition: all  0.2s ease;
    }
    .move-right-enter {
      transform: translate(-100%);
    }
    .move-right-enter-active {
      transition: all 0.2s ease;
    }
    .move-right-leave-active {
      transform: translate(100%);
      transition: all  0.2s ease;
    }
  }
</style>
